import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam, formatText, truncate} from '../utils/utils';

import dsd from "../classes/clsDSD";

import * as PD from '../classes/pdStyle';

class ListProperties extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            Properties : null
        };


        this.dsd = new dsd();
        this.dsd.StateObject = this;

    }

componentDidMount(){

    this.setup();
 
}


componentDidUpdate(prevProps, prevState){

   if (!isEqual(this.props, prevProps)){
       this.setup();
   }

   if (!isEqual(this.state, prevState)){

        if (this.state.isLoaded){
            if (this.state.onLoad){
                this.state.onLoad(this.state.Properties.length);
            }
        }

    }
}


setup(){

    let StateChange = {
        filters: {},
        isLoaded: false,
        columns: {
        },
        onLoad: null

    }

    if (getParam('Properties', this.props)){
        StateChange.Properties = getParam('Properties', this.props);
        if (StateChange.Properties){
            StateChange.isLoaded = true;
        }
    }


    if (getParam('filters', this.props)){
        StateChange.filters = getParam('filters', this.props);
    }

    if (getParam('columns', this.props)){
        StateChange.columns = getParam('columns', this.props);
    }

    if (getParam('onLoad', this.props)){
        StateChange.onLoad = getParam('onLoad', this.props);
    }

    StateChange.load = true;

    this.setState(StateChange);
        
}



    included(Property) {

        let IncludeThis = true;

        return IncludeThis;
    }

    render() {


        if (this.state.isFailed) {
            return (
                <PD.ErrorBox>
                    A problem has occurred
                </PD.ErrorBox>
            )
        }


        if (this.state.isLoaded) {
            let arrProperties = this.state.Properties;
            if (isArray(arrProperties)){
                if (arrProperties.length > 0){

                    return (
                        <PD.Table className="list">
                            <PD.Thead>
                                <PD.Tr>
                                    <PD.Th>Name</PD.Th>
                                    <PD.Th>Attribute</PD.Th>
                                    <PD.Th>Data Type</PD.Th>
                                    <PD.Th>Occurs</PD.Th>
                                    <PD.Th>Required</PD.Th>
                                </PD.Tr>
                            </PD.Thead>

                            <PD.Tbody>

                            {
                                arrProperties.map(
                                    (Property, pos) => 
                                    {
                                        if (this.included(Property)) {

                                            let maxRows = 1;

                                            let Rows = []
                                            for (let i = 1; i <= maxRows; i++) {
                                                Rows.push(null);
                                            }
                
                                            return (
                                                <React.Fragment key={pos}>
                                                    <PD.Tr>
                                                        <PD.Td>
                                                            {Property.name}
                                                        </PD.Td>
                                                        <PD.Td>
                                                            {Property.sourceType=='attribute' && Property.Attribute &&
                                                                Property.Attribute.name
                                                            }
                                                        </PD.Td>
                                                        <PD.Td>
                                                            {Property.complex != true &&
                                                                Property.dataType
                                                            }
                                                        </PD.Td>
                                                        <PD.Td>
                                                            {Property.occurs}
                                                        </PD.Td>
                                                        <PD.Td>
                                                            {Property.required}
                                                        </PD.Td>
                                                    </PD.Tr>
                                                    {Property.description && Property.description.trim() &&
                                                        <PD.Tr key={pos}_description>
                                                            <PD.Td/>
                                                            <PD.Td colSpan="10">
                                                                <PD.MdPresent>{truncate(Property.description, 400)}</PD.MdPresent>
                                                            </PD.Td>
                                                        </PD.Tr>
                                                    }
                                                </React.Fragment>
                                            )
                                        }
                                        else{
                                            return null;
                                        }                
                                    }
                                )
                            }
                            </PD.Tbody>

                        </PD.Table>
                    )
                }
            }
        }

        return <div />;

    };    
};
        
export default function ListProperties_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ListProperties {...props} navigation={navigation} location={location} params={params} />;
  }
